import { render, staticRenderFns } from "./AsterLeads.vue?vue&type=template&id=05d2c042&"
import script from "./AsterLeads.vue?vue&type=script&lang=js&"
export * from "./AsterLeads.vue?vue&type=script&lang=js&"
import style0 from "./AsterLeads.vue?vue&type=style&index=0&id=05d2c042&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports